import { TStates } from '@Managers/StateMachine/StateMachine.types';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { StatesDefault } from '@Managers/StateManager/GameStatesDefault';

export interface ICurrentConditionItem {
    name: string;
    resolved?: string;
}

export interface ICurrentSubConditionItem {
    name: string;
    entry: Array<ICurrentConditionItem>;
    leave: Array<ICurrentConditionItem>;
}

export interface IStateManagerState {
    currentState: EGameStates;
    statesEvents: TStates<EGameStates>;
    currentCoditions: Array<ICurrentConditionItem>;
    currentSubConditions: Array<ICurrentSubConditionItem>;
}
export const RC_STATE_MANAGER_DEFAULTS = {
    currentState: EGameStates.IDLE_STATE,
    statesEvents: StatesDefault,
    currentCoditions: [],
    currentSubConditions: []
};
